
import React from 'react';

import ReactDOM from 'react-dom';

import { Button,Input} from "@jd/find-react";
 

import KeeVue from '../base/KeeVue.js'

import $ from 'jquery';


export default class FsText extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				isShow: false,
				randId: this.getRandString(),
				isShowMenu: false,
				toHide: false,
				contenteditable: false,
				isScrolling: false,
				selectItem: null,
				menuStyle: {
					left: 5,
					top: 0,
					width: 0,
					height: 0,
				},
				listData: null,
				tempValue:null,
				lianJi:0,
				mode:'view',
			}
		
}

componentWillMount(){
			var that = this;
			this.registComponent();
			this.setVueAttr(this.props.component, "contenteditable", false);
			this.setVueAttr(this.props.component.style, "overflow", "visible");
			if(this.props.component.style.position==='absolute')
			{
				if(this.props.component.style.width === null || this.props.component.style.width === "") {
					this.setVueAttr(this.props.component.style, "width", (200) + "px");
					this.setVueAttr(this.props.component.style, "height", (80) + "px");
					this.props.component.style.display = "inline-block";
				}
			}
			else
			{
				this.setVueAttr(this.props.component.style, "width", "");
				this.setVueAttr(this.props.component.style, "height", "");
			}
			if(this.props.component.cp.title===null)
			{
				this.props.component.cp.title = "文本";
			}
			if(this.props.debug)
			{
				this.onEvent("mouse.up", function() {
					setTimeout(function(){
						if(that.component.isSelected!==true)
						{
							console.log("设置为非编辑状态")
							that.component.contenteditable = false;
						}
						that.lianJi = 0;
					},30);
				});
			}
			
		}

			onMousedown=(event)=> {
				if(this.props.component.contenteditable === true) {
					console.log("阻止冒泡");
					event.preventDefault();
				}
			} 
			changeToEditModeTwo=(event)=>{
				var that = this;
				if(this.lianJi===1)
				{
					this.changeToEditMode(event);
				}
				this.lianJi = 1;
				setTimeout(function(){
					that.lianJi = 0;
				},300);
			} 
			changeToEditMode=(event)=> {
				if(this.debug===true)
				{
					this.props.component.contenteditable = true;
				this.tempValue = this.props.component.cp.title;
				var that = this;
				setTimeout(function(){
					that.$refs.editor.focus();
				},50);
				}
			} 
			changeText=()=>{
				console.log("this.$refs.editor.innerText:"+this.$refs.editor.innerText);
				console.log("this.$refs.editor.innerHTML:"+this.$refs.editor.innerHTML);
				this.props.component.cp.title = this.$refs.editor.innerHTML;
			} 
			onPaste=(e)=> {
				if(this.props.component.isHtmlEditor !== true) {
					return true;
				}
				e.preventDefault();
				var that = this;
				if(!(e.clipboardData && e.clipboardData.items)) {
					return;
				}
				for(var i = 0, len = e.clipboardData.items.length; i < len; i++) {
					var item = e.clipboardData.items[i];
					if(item.kind === "string") {
						item.getAsString(function(str) {
							console.log(str);
							var temp = str.substring(0, str.indexOf("\n"));
							that.component.cp.title += temp;
							var content = str.substring(str.indexOf("\n") + 1);
							that.sendEvent("pasteTxt", that.component, content);
						})
						break;
					} else if(item.kind === "file") {
						var f = item.getAsFile();
						console.log(f);
						break;
					}
				}
				return false;
			} 
			onKeydown=(event)=> {
				if(this.props.component.isHtmlEditor !== true) {
					return true;
				}
				var keycode = window.event ? event.keyCode : event.which;
				var evt = event || window.event;
				if(keycode === 13) {
					this.sendEvent("enterkey", this.props.component);
					event.preventDefault();
					return false;
				}
			}
			
			changeMode=()=>{
				if(this.props.debug)
				{
					this.state.mode="input";
					this.refresh();
				}
				
			}
			
			handleBlur=()=>{
				this.state.mode="view";
				this.refresh();
			}
			
			onChange=(e)=>{
			   
			   
			   if(this.props.component.cp.maxLength)
			   {
				   if(e.target.value.length>this.props.component.cp.maxLength)
				   {
					   this.props.component.cp.title = e.target.value.substr(0,this.props.component.cp.maxLength);
					   this.showErrorMessage("最多"+this.props.component.cp.maxLength+"个字符");
				   }
				   else
				   {
					   this.props.component.cp.title = e.target.value;
				   }
				   
			   }
			   this.refresh();
			   
			}
		
  render(){
  return(
  
<div   style={{height:' 100%'}} >
	{
	 
		<div className={`kee-fs-text jdcc-news-content`} onClick={this.changeMode} >
			{
				!this.props.debug?(<div>{this.props.component.cp.title}{this.props.component.value}</div>):(
				<div>
				<div  style={{display:(this.state.mode=='view'?'block':'none')}}>{this.props.component.cp.title}{this.props.component.value}</div>
				<div style={{display:(this.state.mode=='view'?'none':'block')}}>
			
				
				 <Input    value={this.props.component.cp.title}
				 
				size="middle"
				type="text"  
				onBlur={()=>this.handleBlur( )}  
				 
				onChange={this.onChange}
				autoComplete="off"  ></Input>
					</div>
				</div>
				)
			}
		 
			
        </div>
		  
	}
     
</div>
  );}
 }
